import * as React from 'react'

import { UserContext } from '../../UserContext'
import { useZustand } from '../../hooks/useZustand'
import { sendToAnalytics } from '../../Analytics'

/**
 * Side-effect-only component (renders nothing). Listens for the legacy
 * `onAICategories` / `offAICategories` events and flips the zustand
 * `currentGraphMode` accordingly, plus emits an analytics event.
 *
 * If/when those events are retired, this component can be deleted
 * entirely.
 */
export default function GraphMenu() {
    const setCurrentGraphMode = useZustand(state => state.setCurrentGraphMode)
    const { username } = React.useContext(UserContext)

    React.useEffect(() => {
        const emitter = window.myEventEmitter
        if (!emitter) return

        const currentApp =
            typeof userFactory !== 'undefined'
                ? userFactory.getCurrentApp()
                : ''

        const onAICategoriesOn = () => {
            setCurrentGraphMode('topics')
            sendToAnalytics({
                userId: username,
                event: 'analytics_action',
                data: { source: currentApp, action: 'show_ai_categories' },
            })
        }
        const onAICategoriesOff = () => {
            setCurrentGraphMode('concepts')
            sendToAnalytics({
                userId: username,
                event: 'analytics_action',
                data: { source: currentApp, action: 'hide_ai_categories' },
            })
        }

        emitter.on('onAICategories', onAICategoriesOn)
        emitter.on('offAICategories', onAICategoriesOff)
        return () => {
            emitter.removeListener?.('onAICategories', onAICategoriesOn)
            emitter.removeListener?.('offAICategories', onAICategoriesOff)
        }
    }, [setCurrentGraphMode, username])

    return null
}
